const getParamString = (params = {}) => 
  Object.entries(params).reduce((acc, param) => `${acc}&${param[0]}=${param[1]}`, ''
)

export default getParamString
